<template>
  <article class="bookmark-item">
    <component
      :is="comp"
      :bookmark="bookmark" :user-id="userId" :membership="membership" :public-mode="publicMode"
      @toggle-select="onToggleSelect"
      @tag-selected="onSelectTag"
      @favorite="onAction('favorite', $event)"
      @save="onAction('save', $event)"
      @comments="onAction('comments', $event)"
      @add-to-collection="onAction('add-to-collection', $event)"
      @add-to-collection-from-collection="onAction('add-to-collection-from-collection', $event)"
      @like="onAction('like', $event)"
      @likes="onAction('likes', $event)"
      @pin-edit="onAction('pin-edit', $event)"
    />

    <BookmarkTagsFilter
      v-if="dirty"
      v-model="tagsFilterOpen"
      :activator="$el" :bookmark="menuBookmark || bookmark" :user-id="userId"
      :membership="membership"
      :public-mode="publicMode"
      @submit="$emit('filter-tags', $event)"
      @edit="onAction('tags', $event)"
    />
  </article>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue'
import { ITEM_LAYOUT_STYLE } from '@/utils/constants'
import BookmarkCard from './BookmarkCard.vue'
import BookmarkListItem from './BookmarkListItem.vue'
import BookmarkHeadline from './BookmarkHeadline.vue'
import BookmarkTile from './BookmarkTile.vue'
import BookmarkTagsFilter from './BookmarkTagsFilter.vue'

const props = defineProps({
  // Accepts both Bookmark and CollectionItem (when resourceType is 'bookmark')
  bookmark: {
    type: Object,
    required: true,
  },
  userId: {
    type: String,
    default: null,
  },
  membership: {
    type: Object,
    default: null,
  },
  listStyle: {
    type: String,
    default: 'card',
  },
  publicMode: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['action', 'filter-tags'])

const STYLES = {
  [ITEM_LAYOUT_STYLE.cards]: BookmarkCard,
  [ITEM_LAYOUT_STYLE.list]: BookmarkListItem,
  [ITEM_LAYOUT_STYLE.headlines]: BookmarkHeadline,
  [ITEM_LAYOUT_STYLE.tiles]: BookmarkTile,
}

const dirty = ref(false)
const tagsFilterOpen = ref(false)
const menuBookmark = ref(null)

watch(() => props.bookmark?._id, (newId, oldId) => {
  if (newId === oldId) return
  if (tagsFilterOpen.value) return
  dirty.value = false
  menuBookmark.value = null
})

watch(tagsFilterOpen, val => {
  if (!val) menuBookmark.value = null
})

const comp = computed(() => STYLES[props.listStyle])

function onSelectTag() {
  menuBookmark.value = props.bookmark
  dirty.value = true
  tagsFilterOpen.value = true
}

function onAction(action, event) {
  emit('action', { action, event })
}

function onToggleSelect(event) {
  emit('action', { action: 'toggle-select', event })
}
</script>
